// extracted by mini-css-extract-plugin
export var section = "videoBlock-module--section--DULkL";
export var container = "videoBlock-module--container--2E2gJ";
export var textWrap = "videoBlock-module--textWrap--cfIr7";
export var title = "videoBlock-module--title--BZNTc";
export var brief = "videoBlock-module--brief--hx0E0";
export var video = "videoBlock-module--video--3RMgg";
export var playButton = "videoBlock-module--playButton--cbBhP";